import { combineEpics } from 'redux-observable';

import { findLanguagesEpic }  from './FindLanguages/FindLanguagesEpic';


export default combineEpics(
    findLanguagesEpic,
);
